import { z } from 'zod'

import {
  DeclarableSourceTypeSchema,
  MaintenanceSourceParentSchema,
} from './maintenance-programs'

export const CHANGE_REQUEST_MAX_EDITABLE_NOTES = 20
export const CHANGE_REQUEST_COMMAND_MAX_CHARS = 50_000
export const CHANGE_REQUEST_TITLE_MAX_CHARS = 120

/** What a change request's opening round may change, and where it may search:
 *  without source types or parents, it does not search at all. */
const ChangeRequestThreadScopeSchema = z
  .object({
    editableNoteIds: z
      .array(z.string().min(1).max(100))
      .min(1)
      .max(CHANGE_REQUEST_MAX_EDITABLE_NOTES),
    sourceTypes: z.array(DeclarableSourceTypeSchema).max(10).optional(),
    sourceParents: z.array(MaintenanceSourceParentSchema).max(20).optional(),
  })
  .strict()
export type ChangeRequestThreadScope = z.infer<
  typeof ChangeRequestThreadScopeSchema
>

export const ChangeRequestThreadRequestSchema = z
  .object({
    agentRunId: z.string().min(1).max(100),
    // Chosen by the api, so it can find the thread when no answer comes back.
    threadId: z.string().min(1).max(100),
    command: z.string().min(1).max(CHANGE_REQUEST_COMMAND_MAX_CHARS),
    scope: ChangeRequestThreadScopeSchema,
    title: z.string().min(1).max(CHANGE_REQUEST_TITLE_MAX_CHARS).optional(),
  })
  .strict()
export type ChangeRequestThreadRequest = z.infer<
  typeof ChangeRequestThreadRequestSchema
>

export type ChangeRequestThreadResponse =
  | { status: 'processing'; threadId: string }
  | { status: 'error'; error: string }
